import React, { FC } from 'react';
import { AuthPageWrapper } from '../AuthPageLayout';
import { ConfirmPasswordChangePage } from 'features';

/**
 * This component renders the Confirm Password Change page.
 */
export const ConfirmPasswordChange: FC = () => {
  return (
    <AuthPageWrapper>
      <ConfirmPasswordChangePage />
    </AuthPageWrapper>
  );
};
